import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36d280e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-circle symbol-35px me-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "symbol-label border border-primary border-dashed" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "far fa-copy fs-3 text-primary" })
  ])
], -1))
const _hoisted_2 = { class: "modal-scroll-container rounded-bottom px-7 pt-7 position-relative bg-light scroll-y" }
const _hoisted_3 = { class: "table-responsive" }
const _hoisted_4 = { class: "table align-top table-row-bordered mb-0 fs-6 min-w-300px g-1" }
const _hoisted_5 = { class: "fw-bold text-gray-600" }
const _hoisted_6 = {
  class: "text-muted ps-5 min-w-125px",
  colspan: "2"
}
const _hoisted_7 = { class: "d-block" }
const _hoisted_8 = { class: "required" }
const _hoisted_9 = { class: "fv-plugins-message-container text-start" }
const _hoisted_10 = { class: "fv-help-block" }
const _hoisted_11 = {
  class: "text-muted ps-5 min-w-125px",
  colspan: "2"
}
const _hoisted_12 = { class: "d-block" }
const _hoisted_13 = { class: "required" }
const _hoisted_14 = { class: "fv-plugins-message-container text-start" }
const _hoisted_15 = {
  class: "fv-help-block",
  ref: "codeError"
}
const _hoisted_16 = {
  class: "text-muted ps-5 min-w-125px",
  colspan: "2"
}
const _hoisted_17 = { class: "d-block mb-2 required" }
const _hoisted_18 = { class: "" }
const _hoisted_19 = { class: "position-relative align-items-center" }
const _hoisted_20 = { class: "fv-plugins-message-container text-start" }
const _hoisted_21 = { class: "fv-help-block" }
const _hoisted_22 = {
  class: "text-muted ps-5 min-w-125px",
  colspan: "2"
}
const _hoisted_23 = { class: "d-block mb-2" }
const _hoisted_24 = { class: "required" }
const _hoisted_25 = { class: "fv-plugins-message-container text-start" }
const _hoisted_26 = { class: "fv-help-block" }
const _hoisted_27 = {
  class: "text-muted ps-5 min-w-125px",
  colspan: "2"
}
const _hoisted_28 = { class: "d-block mb-2" }
const _hoisted_29 = { class: "" }
const _hoisted_30 = { class: "fv-plugins-message-container text-start" }
const _hoisted_31 = { class: "fv-help-block" }
const _hoisted_32 = {
  class: "text-muted ps-5 min-w-125px",
  colspan: "2"
}
const _hoisted_33 = { class: "d-block mb-2" }
const _hoisted_34 = { class: "required" }
const _hoisted_35 = { class: "input-group mb-3" }
const _hoisted_36 = {
  key: 0,
  class: "fas fa-edit text-primary fs-6"
}
const _hoisted_37 = {
  key: 1,
  class: "fas fa-plus text-primary fs-6"
}
const _hoisted_38 = { class: "fv-plugins-message-container text-start" }
const _hoisted_39 = { class: "fv-help-block" }
const _hoisted_40 = {
  class: "text-muted ps-5 min-w-125px",
  colspan: "2"
}
const _hoisted_41 = { class: "d-block mb-2 required" }
const _hoisted_42 = { class: "" }
const _hoisted_43 = { class: "position-relative align-items-center" }
const _hoisted_44 = { class: "fv-plugins-message-container text-start" }
const _hoisted_45 = { class: "fv-help-block" }
const _hoisted_46 = {
  class: "text-muted ps-5 min-w-125px",
  colspan: "1"
}
const _hoisted_47 = { class: "d-block mb-2" }
const _hoisted_48 = { class: "required" }
const _hoisted_49 = { class: "fv-plugins-message-container text-start" }
const _hoisted_50 = { class: "fv-help-block" }
const _hoisted_51 = {
  class: "text-muted ps-5 min-w-125px",
  colspan: "1"
}
const _hoisted_52 = { class: "d-block mb-2" }
const _hoisted_53 = { class: "" }
const _hoisted_54 = { class: "fv-plugins-message-container text-start" }
const _hoisted_55 = { class: "fv-help-block" }
const _hoisted_56 = {
  colspan: "2",
  class: "ps-5 pe-2"
}
const _hoisted_57 = { class: "d-flex justify-content-between align-items-center mb-2" }
const _hoisted_58 = { class: "mb-2" }
const _hoisted_59 = { class: "text-muted d-block" }
const _hoisted_60 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_61 = { class: "operational-hours-section" }
const _hoisted_62 = { class: "table mb-0" }
const _hoisted_63 = { scope: "col" }
const _hoisted_64 = { scope: "col" }
const _hoisted_65 = { scope: "col" }
const _hoisted_66 = { class: "fw-bold" }
const _hoisted_67 = {
  key: 0,
  class: "text-black"
}
const _hoisted_68 = {
  key: 1,
  class: "d-flex align-items-center"
}
const _hoisted_69 = { class: "d-flex flex-column" }
const _hoisted_70 = {
  key: 0,
  class: "text-danger small mt-1"
}
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mx-2 text-muted" }, "-", -1))
const _hoisted_72 = { class: "d-flex flex-column" }
const _hoisted_73 = {
  key: 0,
  class: "text-danger small mt-1"
}
const _hoisted_74 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_75 = ["id", "onUpdate:modelValue", "onChange"]
const _hoisted_76 = ["for"]
const _hoisted_77 = {
  class: "text-muted ps-5 min-w-125px",
  colspan: "2"
}
const _hoisted_78 = { class: "d-block mb-2" }
const _hoisted_79 = { class: "" }
const _hoisted_80 = { class: "position-relative align-items-center" }
const _hoisted_81 = {
  class: "text-muted ps-5 min-w-125px",
  colspan: "2"
}
const _hoisted_82 = { class: "d-block mb-2" }
const _hoisted_83 = { class: "" }
const _hoisted_84 = { class: "fv-plugins-message-container text-start" }
const _hoisted_85 = { class: "fv-help-block" }
const _hoisted_86 = {
  class: "text-muted",
  colspan: "2"
}
const _hoisted_87 = {
  class: "accordion",
  id: "kt_accordion_1"
}
const _hoisted_88 = {
  key: 0,
  class: "accordion-item"
}
const _hoisted_89 = {
  class: "accordion-header",
  id: "kt_accordion_1_header_2"
}
const _hoisted_90 = {
  class: "accordion-button fs-5 fw-bold text-black-50 collapsed",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_accordion_1_body_2",
  "aria-expanded": "false",
  "aria-controls": "kt_accordion_1_body_2"
}
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-circle symbol-30px me-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "symbol-label border border-primary border-dashed" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-layers fs-4 text-primary" })
  ])
], -1))
const _hoisted_92 = {
  id: "kt_accordion_1_body_2",
  class: "accordion-collapse collapse",
  "aria-labelledby": "kt_accordion_1_header_2",
  "data-bs-parent": "#kt_accordion_1"
}
const _hoisted_93 = { class: "accordion-body" }
const _hoisted_94 = { class: "table-responsive" }
const _hoisted_95 = { class: "table align-middle table-hover table-row-bordered gy-3" }
const _hoisted_96 = { class: "fw-bold text-muted" }
const _hoisted_97 = { class: "w-50px" }
const _hoisted_98 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_99 = ["checked"]
const _hoisted_100 = { class: "min-w-150px text-uppercase" }
const _hoisted_101 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_102 = ["checked", "onClick"]
const _hoisted_103 = { class: "d-flex justify-content-start flex-column" }
const _hoisted_104 = { class: "text-dark text-hover-primary fs-6" }
const _hoisted_105 = {
  key: 1,
  class: "accordion-item"
}
const _hoisted_106 = {
  class: "accordion-header",
  id: "kt_accordion_1_header_4"
}
const _hoisted_107 = {
  class: "accordion-button fs-5 fw-bold text-black-50 collapsed",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_accordion_1_body_4",
  "aria-expanded": "false",
  "aria-controls": "kt_accordion_1_body_4"
}
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-circle symbol-30px me-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "symbol-label border border-primary border-dashed" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-people fs-4 text-primary" })
  ])
], -1))
const _hoisted_109 = {
  id: "kt_accordion_1_body_4",
  class: "accordion-collapse collapse",
  "aria-labelledby": "kt_accordion_1_header_4",
  "data-bs-parent": "#kt_accordion_1"
}
const _hoisted_110 = { class: "accordion-body" }
const _hoisted_111 = { class: "table-responsive" }
const _hoisted_112 = { class: "table align-middle table-hover table-row-bordered gy-3" }
const _hoisted_113 = { class: "fw-bold text-muted" }
const _hoisted_114 = { class: "w-50px" }
const _hoisted_115 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_116 = ["checked"]
const _hoisted_117 = { class: "min-w-150px text-uppercase" }
const _hoisted_118 = { class: "min-w-140px text-uppercase" }
const _hoisted_119 = { class: "min-w-120px text-uppercase" }
const _hoisted_120 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_121 = ["checked", "onClick"]
const _hoisted_122 = { class: "d-flex align-items-center" }
const _hoisted_123 = { class: "d-flex justify-content-start flex-column" }
const _hoisted_124 = { class: "text-dark text-hover-primary fs-6" }
const _hoisted_125 = { class: "text-dark text-hover-primary d-block fs-6" }
const _hoisted_126 = { class: "" }
const _hoisted_127 = {
  key: 2,
  class: "accordion-item"
}
const _hoisted_128 = {
  class: "accordion-header",
  id: "kt_accordion_1_header_5"
}
const _hoisted_129 = {
  class: "accordion-button fs-5 fw-bold text-black-50 collapsed",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_accordion_1_body_5",
  "aria-expanded": "false",
  "aria-controls": "kt_accordion_1_body_5"
}
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-circle symbol-30px me-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "symbol-label border border-primary border-dashed" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-geo-alt fs-4 text-primary" })
  ])
], -1))
const _hoisted_131 = {
  id: "kt_accordion_1_body_5",
  class: "accordion-collapse collapse",
  "aria-labelledby": "kt_accordion_1_header_5",
  "data-bs-parent": "#kt_accordion_1"
}
const _hoisted_132 = { class: "accordion-body" }
const _hoisted_133 = { class: "table-responsive" }
const _hoisted_134 = { class: "table align-middle table-hover table-row-bordered gy-3" }
const _hoisted_135 = { class: "fw-bold text-muted" }
const _hoisted_136 = { class: "w-50px" }
const _hoisted_137 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_138 = ["checked"]
const _hoisted_139 = { class: "min-w-150px text-uppercase" }
const _hoisted_140 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_141 = ["checked", "onClick"]
const _hoisted_142 = { class: "d-flex align-items-center" }
const _hoisted_143 = { class: "d-flex justify-content-start flex-column" }
const _hoisted_144 = { class: "text-dark text-hover-primary fs-6" }
const _hoisted_145 = { class: "site-clone-modal-footer d-flex justify-content-between items-center bg-white position-sticky bottom-0 py-7" }
const _hoisted_146 = ["data-kt-indicator"]
const _hoisted_147 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_148 = { class: "svg-icon svg-icon-3 me-0" }
const _hoisted_149 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_150 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_el_time_picker = _resolveComponent("el-time-picker")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Form = _resolveComponent("Form")!
  const _component_AddAddressModal = _resolveComponent("AddAddressModal")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.dialogVisible) = $event)),
    title: _ctx.dialogTitle,
    "append-to-body": true,
    "close-on-click-modal": false,
    "close-on-press-escape": false,
    center: "",
    "modal-class": "site-clone-dialog",
    onClose: _ctx.discard
  }, {
    header: _withCtx(() => [
      _createElementVNode("h2", null, [
        _hoisted_1,
        _createTextVNode(" " + _toDisplayString(_ctx.translate("common.clone")) + " - " + _toDisplayString(_ctx.siteObj?.name), 1)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_Form, {
        id: "kt_modal_new_target_form",
        onSubmit: _ctx.submitCloneData,
        ref: "cloneSiteRef",
        class: "form",
        "validation-schema": _ctx.cloneSiteData.validationSchema
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("table", _hoisted_4, [
                _createElementVNode("tbody", _hoisted_5, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.translate("common.name")), 1)
                      ]),
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "name",
                        autocomplete: "off",
                        modelValue: _ctx.cloneTargetData['name'],
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.cloneTargetData['name']) = $event)),
                        class: "form-control"
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(_component_ErrorMessage, { name: "name" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.translate("common.number")), 1)
                      ]),
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "code",
                        required: "",
                        placeholder: "",
                        autocomplete: "off",
                        modelValue: _ctx.cloneTargetData['code'],
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.cloneTargetData['code']) = $event)),
                        class: "form-control"
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _createVNode(_component_ErrorMessage, { name: "code" })
                        ], 512)
                      ])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.translate("common.siteLevel")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createVNode(_component_Field, {
                          name: "branchType",
                          modelValue: _ctx.cloneTargetData['branchType'],
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.cloneTargetData['branchType']) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              filterable: "",
                              placeholder: "Please select branch",
                              modelValue: _ctx.cloneTargetData['branchType'],
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.cloneTargetData['branchType']) = $event))
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.branchOptions, (option, index) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: index,
                                    label: option.label,
                                    value: option.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, [
                            _createVNode(_component_ErrorMessage, { name: "branchType" })
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.translate("common.email")), 1)
                      ]),
                      _createVNode(_component_Field, {
                        type: "email",
                        name: "storeEmail",
                        placeholder: "Email@example.com",
                        modelValue: _ctx.cloneTargetData['storeEmail'],
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.cloneTargetData['storeEmail']) = $event)),
                        class: "form-control",
                        autocomplete: "off"
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _createVNode(_component_ErrorMessage, { name: "storeEmail" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.translate("pages.site.website")), 1)
                      ]),
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "website",
                        placeholder: "",
                        autocomplete: "off",
                        modelValue: _ctx.cloneTargetData['website'],
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.cloneTargetData['website']) = $event)),
                        class: "form-control"
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          _createVNode(_component_ErrorMessage, { name: "website" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.translate("common.address")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_35, [
                        _createVNode(_component_Field, {
                          type: "text",
                          name: "address",
                          disabled: true,
                          placeholder: "Address Line 1, City, State, Zip, Country",
                          value: _ctx.cloneTargetData['address'],
                          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.cloneTargetData['address']) = $event)),
                          modelValue: _ctx.cloneTargetData['address'],
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.cloneTargetData['address']) = $event)),
                          class: "form-control"
                        }, null, 8, ["value", "modelValue"]),
                        _createElementVNode("span", {
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showAddModal())),
                          class: "input-group-text w-40px justify-content-center",
                          style: {"cursor":"pointer"}
                        }, [
                          false
                            ? (_openBlock(), _createElementBlock("i", _hoisted_36))
                            : (_openBlock(), _createElementBlock("i", _hoisted_37))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, [
                          _createVNode(_component_ErrorMessage, { name: "address" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("label", _hoisted_42, _toDisplayString(_ctx.translate("common.timezone")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_43, [
                        _createVNode(_component_Field, {
                          name: "timezone",
                          modelValue: _ctx.cloneTargetData['timezone'],
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.cloneTargetData['timezone']) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              filterable: "",
                              placeholder: "Please select time zone",
                              modelValue: _ctx.cloneTargetData['timezone'],
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.cloneTargetData['timezone']) = $event))
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timeZoneList, (option, index) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: index,
                                    label: option.label,
                                    value: option.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_44, [
                          _createElementVNode("div", _hoisted_45, [
                            _createVNode(_component_ErrorMessage, { name: "timezone" })
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_46, [
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("label", _hoisted_48, _toDisplayString(_ctx.translate("common.startDate")), 1)
                      ]),
                      _createVNode(_component_Field, {
                        name: "startDate",
                        modelValue: _ctx.cloneTargetData['startDate'],
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.cloneTargetData['startDate']) = $event))
                      }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_component_Datepicker, _mergeProps({
                            placeholder: _ctx.translate('common.selectDate'),
                            modelValue: _ctx.cloneTargetData['startDate'],
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.cloneTargetData['startDate']) = $event)),
                            enableTimePicker: false,
                            format: _ctx.displayDate,
                            "model-type": "yyyy-MM-dd",
                            autoApply: true
                          }, field, {
                            "min-date": _ctx.minDate,
                            teleport: "body"
                          }), null, 16, ["placeholder", "modelValue", "format", "min-date"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("div", _hoisted_50, [
                          _createVNode(_component_ErrorMessage, { name: "startDate" })
                        ])
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_51, [
                      _createElementVNode("div", _hoisted_52, [
                        _createElementVNode("label", _hoisted_53, _toDisplayString(_ctx.translate("common.endDate")), 1)
                      ]),
                      _createVNode(_component_Field, {
                        name: "endDate",
                        modelValue: _ctx.cloneTargetData['endDate'],
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.cloneTargetData['endDate']) = $event))
                      }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_component_Datepicker, _mergeProps({
                            placeholder: _ctx.translate('common.selectDate'),
                            modelValue: _ctx.cloneTargetData['endDate'],
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.cloneTargetData['endDate']) = $event)),
                            enableTimePicker: false,
                            format: _ctx.displayDate,
                            "model-type": "yyyy-MM-dd",
                            autoApply: true
                          }, field, {
                            "min-date": _ctx.minEndDate,
                            teleport: "body"
                          }), null, 16, ["placeholder", "modelValue", "format", "min-date"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_54, [
                        _createElementVNode("div", _hoisted_55, [
                          _createVNode(_component_ErrorMessage, { name: "endDate" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_56, [
                      _createElementVNode("div", _hoisted_57, [
                        _createElementVNode("div", _hoisted_58, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.translate("pages.site.operationalHours")), 1),
                          _createElementVNode("small", _hoisted_59, _toDisplayString(_ctx.translate("pages.site.optional")), 1)
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[15] || (_cache[15] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleOperationalHours && _ctx.toggleOperationalHours(...args)), ["stop"])),
                          class: _normalizeClass(["btn btn-sm btn-link p-0 text-primary", { 'text-danger': _ctx.operationalHoursEnabled }])
                        }, _toDisplayString(_ctx.operationalHoursEnabled
                          ? `- ${_ctx.translate(
                              "pages.site.removeOperationalHours"
                            )}`
                          : `+ ${_ctx.translate("pages.site.addOperationalHours")}`), 3)
                      ]),
                      _createVNode(_component_Field, {
                        name: "operationHours",
                        modelValue: _ctx.cloneTargetData['operationHours'],
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.cloneTargetData['operationHours']) = $event))
                      }, {
                        default: _withCtx(() => [
                          (
                        _ctx.operationalHoursEnabled &&
                        _ctx.cloneTargetData['operationHours']?.week
                      )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                                _createElementVNode("div", _hoisted_61, [
                                  _createElementVNode("table", _hoisted_62, [
                                    _createElementVNode("thead", null, [
                                      _createElementVNode("tr", null, [
                                        _createElementVNode("th", _hoisted_63, _toDisplayString(_ctx.translate("pages.site.day")), 1),
                                        _createElementVNode("th", _hoisted_64, _toDisplayString(_ctx.translate("pages.site.hours")), 1),
                                        _createElementVNode("th", _hoisted_65, _toDisplayString(_ctx.translate("pages.site.closed")), 1)
                                      ])
                                    ]),
                                    _createElementVNode("tbody", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.daysOfWeek, (day, dayIndex) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                          key: day.value
                                        }, [
                                          _createElementVNode("td", _hoisted_66, _toDisplayString(day.label), 1),
                                          _createElementVNode("td", null, [
                                            (
                                      _ctx.cloneTargetData['operationHours']?.week?.[
                                        day.value
                                      ]?.closed
                                    )
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_67, _toDisplayString(_ctx.translate("pages.site.closed")), 1))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_68, [
                                                  _createElementVNode("div", _hoisted_69, [
                                                    _createVNode(_component_el_time_picker, {
                                                      class: "starting-hour",
                                                      modelValue: 
                                          _ctx.cloneTargetData['operationHours']
                                            .week[day.value].open
                                        ,
                                                      "onUpdate:modelValue": ($event: any) => ((
                                          _ctx.cloneTargetData['operationHours']
                                            .week[day.value].open
                                        ) = $event),
                                                      format: "hh:mm A",
                                                      "value-format": "HH:mm",
                                                      placeholder: "From",
                                                      clearable: "",
                                                      size: "small",
                                                      "popper-class": "time-picker-popper",
                                                      "popper-options": 
                                          _ctx.timePickerPopperOptions
                                        
                                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "popper-options"]),
                                                    (
                                          _ctx.getOperationalHoursOpenError(
                                            day.value
                                          )
                                        )
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_70, _toDisplayString(_ctx.getOperationalHoursOpenError(
                                            day.value
                                          )), 1))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _hoisted_71,
                                                  _createElementVNode("div", _hoisted_72, [
                                                    _createVNode(_component_el_time_picker, {
                                                      class: "ending-hour",
                                                      modelValue: 
                                          _ctx.cloneTargetData['operationHours']
                                            .week[day.value].close
                                        ,
                                                      "onUpdate:modelValue": ($event: any) => ((
                                          _ctx.cloneTargetData['operationHours']
                                            .week[day.value].close
                                        ) = $event),
                                                      format: "hh:mm A",
                                                      "value-format": "HH:mm",
                                                      placeholder: "To",
                                                      clearable: "",
                                                      size: "small",
                                                      "popper-class": "time-picker-popper",
                                                      "popper-options": 
                                          _ctx.timePickerPopperOptions
                                        
                                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "popper-options"]),
                                                    (
                                          _ctx.getOperationalHoursCloseError(
                                            day.value
                                          )
                                        )
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_73, _toDisplayString(_ctx.getOperationalHoursCloseError(
                                            day.value
                                          )), 1))
                                                      : _createCommentVNode("", true)
                                                  ])
                                                ]))
                                          ]),
                                          _createElementVNode("td", null, [
                                            _createElementVNode("div", _hoisted_74, [
                                              _withDirectives(_createElementVNode("input", {
                                                class: "form-check-input",
                                                type: "checkbox",
                                                id: `closed-switch-${dayIndex}`,
                                                "onUpdate:modelValue": ($event: any) => ((
                                        _ctx.cloneTargetData['operationHours'].week[
                                          day.value
                                        ].closed
                                      ) = $event),
                                                onChange: ($event: any) => (_ctx.onClosedChange(day.value))
                                              }, null, 40, _hoisted_75), [
                                                [_vModelCheckbox, 
                                        _ctx.cloneTargetData['operationHours'].week[
                                          day.value
                                        ].closed
                                      ]
                                              ]),
                                              _createElementVNode("label", {
                                                class: "form-check-label",
                                                for: `closed-switch-${dayIndex}`
                                              }, null, 8, _hoisted_76)
                                            ])
                                          ])
                                        ]))
                                      }), 128))
                                    ])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_77, [
                      _createElementVNode("div", _hoisted_78, [
                        _createElementVNode("label", _hoisted_79, _toDisplayString(_ctx.translate("common.status")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_80, [
                        _createVNode(_component_Field, {
                          modelValue: _ctx.cloneTargetData['status'],
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.cloneTargetData['status']) = $event)),
                          name: "status"
                        }, {
                          default: _withCtx(({ field }) => [
                            _createVNode(_component_el_input, _mergeProps(field, {
                              modelValue: _ctx.cloneTargetData['status'],
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.cloneTargetData['status']) = $event)),
                              disabled: ""
                            }), null, 16, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_81, [
                      _createElementVNode("div", _hoisted_82, [
                        _createElementVNode("label", _hoisted_83, _toDisplayString(_ctx.translate("pages.site.description")), 1)
                      ]),
                      _createVNode(_component_Field, {
                        name: "description",
                        placeholder: "",
                        autocomplete: "off",
                        modelValue: _ctx.cloneTargetData['description'],
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.cloneTargetData['description']) = $event)),
                        class: "form-control"
                      }, {
                        default: _withCtx(({ field }) => [
                          _withDirectives(_createElementVNode("textarea", _mergeProps({
                            rows: "3",
                            class: "form-control min-h-75px"
                          }, field, {
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.cloneTargetData['description']) = $event))
                          }), null, 16), [
                            [_vModelText, _ctx.cloneTargetData['description']]
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_84, [
                        _createElementVNode("div", _hoisted_85, [
                          _createVNode(_component_ErrorMessage, { name: "description" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_86, [
                      _createElementVNode("div", _hoisted_87, [
                        (_ctx.cloneSiteData?.cloneForms?.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                              _createElementVNode("h2", _hoisted_89, [
                                _createElementVNode("button", _hoisted_90, [
                                  _hoisted_91,
                                  _createTextVNode(" " + _toDisplayString(_ctx.translate("common.forms")), 1)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_92, [
                                _createElementVNode("div", _hoisted_93, [
                                  _createElementVNode("div", _hoisted_94, [
                                    _createElementVNode("table", _hoisted_95, [
                                      _createElementVNode("thead", null, [
                                        _createElementVNode("tr", _hoisted_96, [
                                          _createElementVNode("th", _hoisted_97, [
                                            _createElementVNode("div", _hoisted_98, [
                                              _createElementVNode("input", {
                                                class: "form-check-input",
                                                type: "checkbox",
                                                checked: 
                                          _ctx.cloneTargetData?.cloneForms?.length >
                                            0 &&
                                          _ctx.cloneTargetData?.cloneForms?.length ==
                                            _ctx.cloneSiteData?.cloneForms?.length
                                        ,
                                                value: "",
                                                onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.selectAll($event, 'cloneForms')))
                                              }, null, 8, _hoisted_99)
                                            ])
                                          ]),
                                          _createElementVNode("th", _hoisted_100, _toDisplayString(_ctx.translate("common.formName")), 1)
                                        ])
                                      ]),
                                      _createElementVNode("tbody", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cloneSiteData.cloneForms, (form, index) => {
                                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                            _createElementVNode("td", null, [
                                              _createElementVNode("div", _hoisted_101, [
                                                _createElementVNode("input", {
                                                  type: "checkbox",
                                                  class: "form-check-input",
                                                  value: "",
                                                  checked: 
                                            _ctx.isChecked('cloneForms', form.webId)
                                          ,
                                                  onClick: ($event: any) => (
                                            _ctx.updateCloneArray(
                                              $event,
                                              form.webId,
                                              'cloneForms'
                                            )
                                          )
                                                }, null, 8, _hoisted_102)
                                              ])
                                            ]),
                                            _createElementVNode("td", null, [
                                              _createElementVNode("div", _hoisted_103, [
                                                _createElementVNode("span", _hoisted_104, _toDisplayString(form.name), 1)
                                              ])
                                            ])
                                          ]))
                                        }), 128))
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.cloneSiteData?.cloneUsers?.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                              _createElementVNode("h2", _hoisted_106, [
                                _createElementVNode("button", _hoisted_107, [
                                  _hoisted_108,
                                  _createTextVNode(" " + _toDisplayString(_ctx.translate("common.users")), 1)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_109, [
                                _createElementVNode("div", _hoisted_110, [
                                  _createElementVNode("div", _hoisted_111, [
                                    _createElementVNode("table", _hoisted_112, [
                                      _createElementVNode("thead", null, [
                                        _createElementVNode("tr", _hoisted_113, [
                                          _createElementVNode("th", _hoisted_114, [
                                            _createElementVNode("div", _hoisted_115, [
                                              _createElementVNode("input", {
                                                class: "form-check-input",
                                                type: "checkbox",
                                                value: "",
                                                checked: 
                                          _ctx.cloneTargetData?.cloneUsers?.length >
                                            0 &&
                                          _ctx.cloneTargetData?.cloneUsers?.length ==
                                            _ctx.cloneSiteData?.cloneUsers?.length
                                        ,
                                                onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.selectAll($event, 'cloneUsers')))
                                              }, null, 8, _hoisted_116)
                                            ])
                                          ]),
                                          _createElementVNode("th", _hoisted_117, _toDisplayString(_ctx.translate("common.userName")), 1),
                                          _createElementVNode("th", _hoisted_118, _toDisplayString(_ctx.translate("common.email")), 1),
                                          _createElementVNode("th", _hoisted_119, _toDisplayString(_ctx.translate("common.role")), 1)
                                        ])
                                      ]),
                                      _createElementVNode("tbody", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cloneSiteData.cloneUsers, (user, index) => {
                                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                            _createElementVNode("td", null, [
                                              _createElementVNode("div", _hoisted_120, [
                                                _createElementVNode("input", {
                                                  type: "checkbox",
                                                  class: "form-check-input",
                                                  value: "",
                                                  checked: 
                                            _ctx.isChecked('cloneUsers', user.webId)
                                          ,
                                                  onClick: ($event: any) => (
                                            _ctx.updateCloneArray(
                                              $event,
                                              user.webId,
                                              'cloneUsers'
                                            )
                                          )
                                                }, null, 8, _hoisted_121)
                                              ])
                                            ]),
                                            _createElementVNode("td", null, [
                                              _createElementVNode("div", _hoisted_122, [
                                                _createElementVNode("div", _hoisted_123, [
                                                  _createElementVNode("span", _hoisted_124, _toDisplayString(user.name), 1)
                                                ])
                                              ])
                                            ]),
                                            _createElementVNode("td", null, [
                                              _createElementVNode("span", _hoisted_125, _toDisplayString(user.storeEmail), 1)
                                            ]),
                                            _createElementVNode("td", _hoisted_126, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(user.roleName?.split(','), (role, index) => {
                                                return (_openBlock(), _createElementBlock("span", {
                                                  key: index,
                                                  class: _normalizeClass(["badge fs-7", _ctx.getClass(role)])
                                                }, _toDisplayString(role), 3))
                                              }), 128))
                                            ])
                                          ]))
                                        }), 128))
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.cloneSiteData?.cloneLocations?.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_127, [
                              _createElementVNode("h2", _hoisted_128, [
                                _createElementVNode("button", _hoisted_129, [
                                  _hoisted_130,
                                  _createTextVNode(" " + _toDisplayString(_ctx.translate("pages.location.title")), 1)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_131, [
                                _createElementVNode("div", _hoisted_132, [
                                  _createElementVNode("div", _hoisted_133, [
                                    _createElementVNode("table", _hoisted_134, [
                                      _createElementVNode("thead", null, [
                                        _createElementVNode("tr", _hoisted_135, [
                                          _createElementVNode("th", _hoisted_136, [
                                            _createElementVNode("div", _hoisted_137, [
                                              _createElementVNode("input", {
                                                class: "form-check-input",
                                                type: "checkbox",
                                                value: "",
                                                checked: 
                                          _ctx.cloneTargetData?.cloneLocations
                                            ?.length > 0 &&
                                          _ctx.cloneTargetData?.cloneLocations
                                            ?.length ==
                                            _ctx.cloneSiteData?.cloneLocations
                                              ?.length
                                        ,
                                                onClick: _cache[23] || (_cache[23] = ($event: any) => (
                                          _ctx.selectAll(
                                            $event,
                                            'cloneLocations',
                                            'locationId'
                                          )
                                        ))
                                              }, null, 8, _hoisted_138)
                                            ])
                                          ]),
                                          _createElementVNode("th", _hoisted_139, _toDisplayString(_ctx.translate("pages.location.locationName")), 1)
                                        ])
                                      ]),
                                      _createElementVNode("tbody", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cloneSiteData.cloneLocations, (location, index) => {
                                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                            _createElementVNode("td", null, [
                                              _createElementVNode("div", _hoisted_140, [
                                                _createElementVNode("input", {
                                                  type: "checkbox",
                                                  class: "form-check-input",
                                                  value: "",
                                                  checked: 
                                            _ctx.isChecked(
                                              'cloneLocations',
                                              location.locationId
                                            )
                                          ,
                                                  onClick: ($event: any) => (
                                            _ctx.updateCloneArray(
                                              $event,
                                              location.locationId,
                                              'cloneLocations'
                                            )
                                          )
                                                }, null, 8, _hoisted_141)
                                              ])
                                            ]),
                                            _createElementVNode("td", null, [
                                              _createElementVNode("div", _hoisted_142, [
                                                _createElementVNode("div", _hoisted_143, [
                                                  _createElementVNode("span", _hoisted_144, _toDisplayString(location.locationName), 1)
                                                ])
                                              ])
                                            ])
                                          ]))
                                        }), 128))
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_145, [
              _createElementVNode("button", {
                type: "reset",
                id: "site_clone_cancel",
                class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px",
                "data-bs-dismiss": "modal",
                onClick: _cache[24] || (_cache[24] = _withModifiers(($event: any) => (_ctx.$emit('on-cancel')), ["stop"]))
              }, _toDisplayString(_ctx.translate("common.close")), 1),
              _createElementVNode("button", {
                "data-kt-indicator": _ctx.loading ? 'on' : null,
                class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px",
                type: "submit"
              }, [
                (!_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_147, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.translate("common.save")), 1),
                      _createElementVNode("span", _hoisted_148, [
                        _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_149, [
                      _createTextVNode(_toDisplayString(_ctx.translate("common.pleaseWait")) + " ", 1),
                      _hoisted_150
                    ]))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_146)
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"]),
      _createVNode(_component_AddAddressModal, {
        showModal: _ctx.showAddressModal,
        data: _ctx.cloneTargetData['address'],
        "onUpdate:modelValue": _ctx.updateShowModalVal,
        isEditable: _ctx.isEditMode,
        onSubmit: _ctx.addressSubmit
      }, null, 8, ["showModal", "data", "onUpdate:modelValue", "isEditable", "onSubmit"])
    ]),
    _: 1
  }, 8, ["modelValue", "title", "onClose"]))
}